import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function CarOverviewHeader({ name, image }) {
  const {
    currentDealerColorTotalCount,
    order
  } = useContext(ConfiguratorContext)

  const dealerOrderType = order.dealer_order_type ?? null
  const totalCount = currentDealerColorTotalCount ?? 1

  if (!name) {
    return null
  }

  return (
    <div className='car-overview__header'>
      {image ? <div className='car-overview__header-image'><img src={image} alt={name}/></div> : null}
      <div className='car-overview__header-text'>
        <p className='car-overview__header-name'>{name}</p>
        {
          dealerOrderType === 'customer_car'
            ? null
            : <div className='car-overview__header-count'>{totalCount}</div>
        }
      </div>
    </div>
  )
}
